import React from 'react';
import colors from "../../../assets/scss/variable/color.scss";
import {StringDiff as StDiff, DiffMethod} from "react-string-diff";


const StringDiffs = ({ before, after, direction }) => {
    // https://github.com/elv1n/react-string-diff?tab=readme-ov-file
    const newStyle = {
      added: {
        // backgroundColor: "lightgreen",
        backgroundColor: colors.added,
        color: colors.white,
      },
      removed: {
        // backgroundColor: 'salmon'
        backgroundColor: colors.removed,
        color: colors.white,
      },
      default: {}
    };
    
    return <StDiff className={`diffs ${direction}`}
                       oldValue={before}
                       newValue={after}
                       method={DiffMethod.Words}
                       styles={newStyle}
    />
}

export default StringDiffs;